import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { INotificationWaveCreated } from "@/types/feed.types";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import { getTimeAgoShort } from "@/helpers/Helpers";
import WaveHeaderFollow, { WaveFollowBtnSize } from "@/components/waves/header/WaveHeaderFollow";
import { ApiWave } from "@/generated/models/ApiWave";
import { commonApiFetch } from "@/services/api/common-api";
import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import NotificationsFollowBtn from "../NotificationsFollowBtn";
import { UserFollowBtnSize } from "@/components/user/utils/UserFollowBtn";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import { getWaveRoute } from "@/helpers/navigation.helpers";
export default function NotificationWaveCreated(t0) {
  const $ = _c(37);
  const {
    notification
  } = t0;
  let t1;
  if ($[0] !== notification.additional_context.wave_id) {
    t1 = {
      queryKey: [QueryKey.WAVE, {
        wave_id: notification.additional_context.wave_id
      }],
      queryFn: async () => await commonApiFetch({
        endpoint: `waves/${notification.additional_context.wave_id}`
      })
    };
    $[0] = notification.additional_context.wave_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data: wave
  } = useQuery(t1);
  const {
    isApp
  } = useDeviceInfo();
  const t2 = wave?.chat.scope.group?.is_direct_message ?? false;
  let t3;
  if ($[2] !== isApp || $[3] !== notification.additional_context.wave_id || $[4] !== t2) {
    t3 = getWaveRoute({
      waveId: notification.additional_context.wave_id,
      isDirectMessage: t2,
      isApp
    });
    $[2] = isApp;
    $[3] = notification.additional_context.wave_id;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const invitationHref = t3;
  let t4;
  if ($[6] !== notification.related_identity.pfp) {
    t4 = <div className="tw-h-7 tw-w-7">{notification.related_identity.pfp ? <img src={getScaledImageUri(notification.related_identity.pfp, ImageScale.W_AUTO_H_50)} alt="#" className="tw-flex-shrink-0 tw-object-contain tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" /> : <div className="tw-flex-shrink-0 tw-object-contain tw-h-full tw-w-full tw-rounded-md tw-bg-iron-800 tw-ring-1 tw-ring-iron-700" />}</div>;
    $[6] = notification.related_identity.pfp;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `/${notification.related_identity.handle}`;
  let t6;
  if ($[8] !== notification.related_identity.handle || $[9] !== t5) {
    t6 = <Link href={t5} className="tw-no-underline tw-font-semibold">{notification.related_identity.handle}</Link>;
    $[8] = notification.related_identity.handle;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className="tw-text-iron-400"> invited you to a wave:</span>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = wave?.name;
  let t9;
  if ($[12] !== invitationHref || $[13] !== t8) {
    t9 = <Link href={invitationHref} className="tw-text-md tw-font-medium tw-no-underline tw-text-primary-400 hover:tw-text-primary-300">{t8}</Link>;
    $[12] = invitationHref;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="tw-font-bold tw-mr-1 tw-text-xs tw-text-iron-400">•</span>;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== notification.created_at) {
    t11 = getTimeAgoShort(notification.created_at);
    $[16] = notification.created_at;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11) {
    t12 = <span className="tw-text-sm tw-text-iron-300 tw-font-normal tw-whitespace-nowrap">{t10}{" "}{t11}</span>;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t6 || $[22] !== t9) {
    t13 = <span className="tw-text-sm tw-font-normal tw-text-iron-50">{t6}{" "}{t7}{" "}{t9}{" "}{t12}</span>;
    $[20] = t12;
    $[21] = t6;
    $[22] = t9;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t13 || $[25] !== t4) {
    t14 = <div className="tw-flex tw-gap-x-2 tw-items-center">{t4}{t13}</div>;
    $[24] = t13;
    $[25] = t4;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== wave) {
    t15 = wave && <WaveHeaderFollow wave={wave} subscribeToAllDrops={true} size={WaveFollowBtnSize.SMALL} />;
    $[27] = wave;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== notification.related_identity) {
    t16 = <NotificationsFollowBtn profile={notification.related_identity} size={UserFollowBtnSize.SMALL} />;
    $[29] = notification.related_identity;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t15 || $[32] !== t16) {
    t17 = <div className="tw-flex tw-gap-x-2 tw-items-center">{t15}{t16}</div>;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t14 || $[35] !== t17) {
    t18 = <div className="tw-w-full tw-inline-flex tw-justify-between gap-2">{t14}{t17}</div>;
    $[34] = t14;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  return t18;
}